import { render, staticRenderFns } from "./DrawModule.vue?vue&type=template&id=298ebe9a&scoped=true"
import script from "./DrawModule.vue?vue&type=script&lang=js"
export * from "./DrawModule.vue?vue&type=script&lang=js"
import style0 from "./DrawModule.vue?vue&type=style&index=0&id=298ebe9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ebe9a",
  null
  
)

export default component.exports